/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventInfo,
    JsonEventInfoFromJSON,
    JsonEventInfoFromJSONTyped,
    JsonEventInfoToJSON,
} from './JsonEventInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventInfo
 */
export interface ApiResultOfListOfJsonEventInfo {
    /**
     * 
     * @type {Array<JsonEventInfo>}
     * @memberof ApiResultOfListOfJsonEventInfo
     */
    data?: Array<JsonEventInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventInfo
     */
    result?: ApiResultOfListOfJsonEventInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventInfoFromJSON(json: any): ApiResultOfListOfJsonEventInfo {
    return ApiResultOfListOfJsonEventInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventInfoToJSON(value?: ApiResultOfListOfJsonEventInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

